import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";
import {
	DeleteButton,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import { EnhancedButtonPrimeReact } from "../../../EnhancedButtonPrimeReact";
import { EnhancedButtonPrimeReactSeverity } from "../../../../common/Common";
import { useSelector } from "react-redux";
import { IAppState } from "../../../../store/reducers";

export interface IClientBankSetupToolbar {
	onResetClicked: () => void;
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
	selectedDataRecord?: any;
}

export const ClientBankSetupToolbar: FC<IClientBankSetupToolbar> = ({
	onResetClicked,
	onDeleteClicked,
	isSubmitting = false,
	id,
	selectedDataRecord
}) => {
	const isAdmin = useSelector((state:IAppState) => state.user.profile.isSuperStatus)
	return (
		<Toolbar>
			<>
				{/* <SubmitButton
					label="Submit"
					testId="submit-button"
					loading={isSubmitting}
					icon={<PlaylistAddCheckOutlinedIcon />}
				/>
				<ResetButton testId="reset-button" onClickHandler={onResetClicked} />
				<DeleteButton testId="delete-button" onClickHandler={onDeleteClicked} /> */}
				<EnhancedButtonPrimeReact
					label="Submit"
					loading={isSubmitting}
					type="submit"
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					disabled={selectedDataRecord && selectedDataRecord.status !== 100 && isAdmin !== 400 ? true : false}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Reset"
					raised
					onClickHandler={onResetClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				{/* <EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					disabled={!id ? true : false}
				/> */}
			</>
		</Toolbar>
	);
};
